"use server";

import { createClient } from "@/utils/supabase/server";

interface SaveArgs {
  userId: string;
  itemType: "post" | "listing";
  itemId: string;
}

export async function saveItem({ userId, itemType, itemId }: SaveArgs) {
  const supabase = await createClient();
  const { data: existing, error: fetchErr } = await supabase
    .from("saved")
    .select("id, deleted_at")
    .eq("user_id", userId)
    .eq("item_type", itemType)
    .eq("item_id", itemId)
    .maybeSingle();
  if (fetchErr) throw new Error(fetchErr.message);
  if (existing) {
    if (existing.deleted_at == null) return;
    const { error: updateErr } = await supabase
      .from("saved")
      .update({ deleted_at: null })
      .eq("id", existing.id);
    if (updateErr) throw new Error(updateErr.message);
    return;
  }
  const { error } = await supabase
    .from("saved")
    .insert({ user_id: userId, item_type: itemType, item_id: itemId });
  if (error) throw new Error(error.message);
}

export async function unsaveItem({ userId, itemType, itemId }: SaveArgs) {
  const supabase = await createClient();
  const { error } = await supabase
    .from("saved")
    .update({ deleted_at: new Date().toISOString() })
    .eq("user_id", userId)
    .eq("item_type", itemType)
    .eq("item_id", itemId)
    .is("deleted_at", null);
  if (error) throw new Error(error.message);
}
